<template>
  <div
    class="banner"
    :style="{
      backgroundImage:
        'url(' + require('@/assets/images/banners/home-banner.png') + ')'
    }"
  >
    <div class="container">
      <h1 class="banner__text">List or rent tools</h1>
      <search-bar></search-bar>
    </div>
  </div>
</template>
<script>
/**
 * ==================================================================================
 * Banner
 * ==================================================================================
 **/

import SearchBar from '@/components/SearchBar'

export default {
  components: {
    SearchBar
  }
}
</script>
<style lang="scss" scoped>
$banner-height: 430px;

.banner {
  position: relative;
  height: $banner-height;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;

  .banner__text {
    width: 100%;
    padding-top: $banner-height * 0.5;
    margin-bottom: 25px;
    color: #fff;
  }
}

@media (max-width: 575px) {
  .banner {
    /* Increase height due to SearchBar.vue height changes on XS screen size */
    height: $banner-height + 40px;
  }
}
</style>
